<div class="notification-container">
    <!-- <i
        severity="danger"
        [value]="unreadCount > 0 ? unreadCount : null"
        class="pi pi-bell mr-4 mt-3 p-text"
        (click)="overlayPanel.toggle($event)"
        pBadge
        style="font-size: 2rem"
    ></i> -->

    <!-- Trường hợp CÓ thông báo mới: Hiển thị chuông kèm số lượng và chấm đỏ -->
    <i
        *ngIf="unreadCount > 0"
        severity="danger"
        [value]="unreadCount"
        class="pi pi-bell mr-4 mt-3 p-text"
        (click)="overlayPanel.toggle($event)"
        pBadge
        style="font-size: 2rem; cursor: pointer"
    ></i>

    <!-- Trường hợp KHÔNG CÓ thông báo: Chỉ hiển thị chuông trơn (Mất hoàn toàn chấm đỏ) -->
    <i
        *ngIf="unreadCount <= 0"
        class="pi pi-bell mr-4 mt-3 p-text"
        (click)="overlayPanel.toggle($event)"
        style="font-size: 2rem; cursor: pointer"
    ></i>

    <!-- Tách thẻ i và thẻ badge ra rồi làm cho thẻ Badge chỉ hiển thị khi có thông báo lớn hơn 0 -->
    <!-- <i
        class="pi pi-bell mr-4 mt-3 p-text clickable"
        (click)="overlayPanel.toggle($event)"
        style="font-size: 2rem; cursor: pointer"
    >
    </i>
    <p-badge
        *ngIf="unreadCount > 0"
        [value]="unreadCount"
        severity="danger"
        styleClass="custom-notification-badge"
    >
    </p-badge> -->
    <!-- ------------- -->

    <p-overlayPanel #overlayPanel [dismissable]="true">
        <div class="notification-header">
            <span>Thông báo</span>
            <a
                class="clickable"
                *ngIf="unreadCount > 0"
                (click)="makeReadAll()"
                style="cursor: pointer"
                >Tick đã đọc hết</a
            >
        </div>
        <ng-container *ngFor="let n of latestNotification">
            <div class="notification-item">
                <div class="notification-content">
                    <div class="notification-title">
                        {{ n.notification_type_name }}
                    </div>
                    <div
                        (click)="
                            viewBookingDetail(n.id, n.notification_type_id)
                        "
                        class="notification-message"
                    >
                        <a class="clickable">{{ n.notification_content }}</a>
                    </div>
                    <div class="notification-time">
                        {{ n.created_at | date: "dd/MM/YYYY - HH:mm" }}
                    </div>
                </div>
                <i
                    class="pi pi-circle-fill unread-indicator clickable"
                    *ngIf="n.status == 0"
                    (click)="makeRead(n.id)"
                ></i>
            </div>
        </ng-container>
    </p-overlayPanel>
</div>
